<template>
  <div class="main">
    <selectTool ref="selectTool"
      ><template slot="btn"
        ><Button @click="getSearchItem" type="error" class="chaxun">查询</Button
        ><Button @click="exportAll" type="primary" class="chaxun"
          >导出</Button
        ></template
      ></selectTool
    >

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
    >
    </Table>
    <div v-if="false" id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
  </div>
</template>
<script>
import chuhuozonglanChild from "./chuhuozonglanChild.vue";
export default {
  data() {
    return {
      isAdd: false,
      openForm: false,
      openYundan: false,
      columns: [
        {
          type: "expand",
          width: 70,
          align: "center",
          render: (h, data) => {
            return h(chuhuozonglanChild, {
              //局部注册组件不需要加引号
              props: {
                data: data.row.listGoods,
                //columns: this.ordersChargesListForms,
              },
            });
          },
        },
        {
          type: "index",
          width: 70,
          align: "center",
          sort: 0,
        },
        {
          title: "总表号码",
          key: "no",
        },
        {
          title: "订单号",
          key: "ono",
        },
        {
          title: "大陆车牌",
          key: "carNo",
        },
        {
          title: "大陆司机",
          key: "driver",
        },
        {
          title: "香港车牌",
          key: "carNoHk",
        },
        {
          title: "香港司机",
          key: "driverHk",
        },
        {
          title: "总重量/kgs",
          key: "totalWeight",
        },
        {
          title: "总件数",
          key: "totalAmount",
        },
        {
          title: "总体积/cbm",
          key: "totalVolume",
        },
        {
          title: "装车时间",
          key: "pickupTime2",
        },
        {
          title: "到港时间",
          key: "timesArrive2",
        },
        {
          title: "交货时间",
          key: "timesUnloadLeave2",
        },
        {
          title: "创建时间",
          key: "createTime2",
        },
        {
          title: "制表人",
          key: "creator",
        },
        {
          title: "标题",
          key: "title",
        },
      ],
      tableData: [],

      searchItem: {
        ono: "",
        startTime: "",
        endTime: "",
      },
      total: 0,
      searchForms: [
        {
          title: "时间范围",
          key: "startTime",
          key1: "endTime",
          required: true,
          val: 0,
          type: "lyyymmdd",
          times: "4,2,0",
        },
        {
          title: "订单号",
          key: "ono",
          type: "Input",
        },
      ],
    };
  },
  methods: {
    reach(v) {
      this.searchItem.ono = v.no;
      this.getSearchItem();
    },
    getList() {
      this.utils.loading(this, "加载中");
      console.log(this.searchItem);
      this.axios({
        method: "post",
        url:
          this.axios.ipPort +
          "/cloud-tms-server-ctc/pickup/pickupShipGoodsReport",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data;
        for (let i = 0; i < data.length; i++) {
          data[i]._expanded = true;
          data[i].pickupTime2 = this.utils.time(
            data[i].pickupTime,
            "yymmddhhmm"
          );
          data[i].createTime2 = this.utils.time(
            data[i].createTime,
            "yymmddhhmm"
          );
          data[i].timesArrive2 = this.utils.time(
            data[i].timesArrive,
            "yymmddhhmm"
          );
          data[i].timesUnloadLeave2 = this.utils.time(
            data[i].timesUnloadLeave,
            "yymmddhhmm"
          );
          data.createTime2 = this.utils.time(data[i].createTime, "yymmddhhmm");
          var ordes = data[i].listGoods;
          for (let j = 0; j < ordes.length; j++) {
            ordes[j].timesUnloadLeave2 = this.utils.time(
              ordes[j].timesUnloadLeave,
              "yymmddhhmm"
            );
          }
        }
        this.tableData = data;
      });
    },
    exportAll() {
      var params = [
        {
          name: "ono",
          value: this.searchItem.ono,
        },
        {
          name: "startTime",
          value: this.searchItem.startTime,
        },
        {
          name: "endTime",
          value: this.searchItem.endTime,
        },
      ];
      this.utils.exportData(
        this.axios.ipPort +
          "/cloud-tms-server-ctc/pickup/exportExcelShipGoogds",
        params
      );
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },
    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.getList();
    },
  },
  mounted() {
    var config = {
      min: 130,
      max: 300,
    };
    this.columns = this.utils.cols([], this.columns, config);
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/wuliu/fahuo/chuhuozonglan.vue